import { render, staticRenderFns } from "./MiniProductCard.vue?vue&type=template&id=5906996d&scoped=true&"
import script from "./MiniProductCard.vue?vue&type=script&lang=js&"
export * from "./MiniProductCard.vue?vue&type=script&lang=js&"
import style0 from "./MiniProductCard.vue?vue&type=style&index=0&id=5906996d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5906996d",
  null
  
)

export default component.exports